export default function Home (props){
    return <h1>This is the Home Component</h1>;
  };